module.exports = __webpack_public_path__ + "static/frito2-28bb08431b7307fa747b3f7249fbe5a6.png";